import { useEffect, useState } from "react";
import Main from "../../../Layout/Main";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { Row, Input, Col, Divider, Table, Select, Modal, Space } from "antd";
import "./styles.css";
import { EmailLogService } from "../../../../services/emaillogs";
import loadingSVG from "../../../../assets/images/loading.svg";
import ModalEvent from "./components/ModalEventInfo";

function EmailsLogPage(props) {
  const [loadingModal, setLoadingModal] = useState(false);
  const [eventData, setEventData] = useState({});
  const [searchQuery, setSearchQuery] = useState(" ");
  const signin = useSelector((state) => state.signin);
  const [selected, setSelected] = useState("");
  const [data, setData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [optionSelected, setOptionSelected] = useState("");

  const options = [
    { value: "Tag", key: "ses_config_set" },

    { value: "E-mail Destinatário", key: "customer_email" },
  ];

  const columns = [
    {
      title: "Tipo do Evento",
      key: "event_type",
      render: (_, record) =>
        record.event_type == "Open"
          ? "Abriu E-mail"
          : record.event_type == "Delivery"
          ? "Entregue"
          : record.event_type == "Send"
          ? "Enviado"
          : record.event_type == "Click"
          ? "Clicou em Link no E-mail"
          : record.event_type == "Bounce"
          ? "E-mail não pôde ser entregue"
          : record.event_type == "Rendering Failure"
          ? "Erro de Renderização"
          : record.event_type == "Complaint"
          ? "Marcou como Spam/Denunciou"
          : record.event_type == "Reject"
          ? "SES rejeitou envio"
          : record.event_type == "DeliveryDelay"
          ? "Entregue com Atraso"
          : "",
    },
    { title: "Enviado Por", key: "send_by", dataIndex: "sender_address" },
    {
      title: "Endereço Destinatário",
      key: "recipient_address_id",
      render: (_, record) => record.EmailCustomer?.address || " ",
    },
    {
      title: "Tag",
      key: "ses_config_set",
      dataIndex: "ses_config_set",
    },
    { title: "Assunto", key: "mail_subject", dataIndex: "mail_subject" },
    {
      title: "Data do Evento",
      key: "event_timestamp",
      render: (_, record) => formatToBrasilia(record.event_timestamp),
    },
  ];

  const { Search } = Input;
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  function formatToBrasilia(utcDateStr) {
    const date = new Date(utcDateStr);

    const options = {
      timeZone: "America/Sao_Paulo",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };

    const formatted = new Intl.DateTimeFormat("pt-BR", options).format(date);

    return formatted.replace(",", " às");
  }

  useEffect(() => {
    fetchData();
  }, [signin.user]);

  const fetchData = async () => {
    setLoading(true);
    const response = await EmailLogService.getAllLogs();
    setPagination({
      current: 1,
      pageSize: pagination.pageSize,
      total: response.count,
    });

    setData(response.rows);
    setLoading(false);
  };

  console.log(optionSelected);

  const getLogs = async (filter) => {
    try {
      setLoading(true);
      setSearchQuery(filter);

      if (selected == "" && !optionSelected == "") {
        console.log(optionSelected);
        const response = await EmailLogService.getByEventType({
          event_type: optionSelected,
          page: 1,
          limit: pagination.pageSize,
        });
        setPagination({
          current: 1,
          pageSize: pagination.pageSize,
          total: response.count,
        });

        setData(response.rows);
        setLoading(false);
      }

      if (selected == "customer_email" && optionSelected == "") {
        const response = await EmailLogService.getAllAddress({
          customer_address: filter,
          page: 1,
          limit: pagination.pageSize,
        });

        setPagination({
          current: 1,
          pageSize: pagination.pageSize,
          total: response.count,
        });

        setData(response.rows);
        setLoading(false);
      }

      if (selected == "customer_email" && !optionSelected == "") {
        const response = await EmailLogService.getByEmailAndEventType({
          recipient_address: filter,
          page: 1,
          limit: pagination.pageSize,
          event_type: optionSelected,
        });

        setPagination({
          current: 1,
          pageSize: pagination.pageSize,
          total: response.count,
        });

        setData(response.data);
        setLoading(false);
      }

      if (selected == "ses_config_set" && optionSelected == "") {
        const response = await EmailLogService.getLogBySesConfig({
          ses_config_set: filter,
          page: 1,
          limit: pagination.pageSize,
          selected: selected,
        });

        setPagination({
          current: 1,
          pageSize: pagination.pageSize,
          total: response.count,
        });

        setData(response.rows);
        setLoading(false);
      }

      if (selected == "ses_config_set" && !optionSelected == "") {
        const response = await EmailLogService.getBySesAndEvenType({
          ses_config_set: filter,
          page: 1,
          limit: pagination.pageSize,
          event_type: optionSelected,
        });

        setPagination({
          current: 1,
          pageSize: pagination.pageSize,
          total: response.count,
        });

        setData(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleTableChange = async (pagi) => {
    setLoading(true);

    const emailparams = {
      customer_address: searchQuery,
      page: pagi.current,
      limit: pagi.pageSize,
    };

    const params = {
      ses_config_set: searchQuery,
      selected: selected,
      page: pagi.current,
      limit: pagi.pageSize,
    };

    if (selected == "" && optionSelected == "") {
      try {
        const response = await EmailLogService.getAllLogsPagination({
          page: pagi.current,
          limit: pagi.pageSize,
        });
        setData(response.rows);
        setPagination({ ...pagi, total: response.count });
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }

    if (selected == "" && !optionSelected == "") {
      try {
        const response = await EmailLogService.getByEventType({
          page: pagi.current,
          limit: pagi.pageSize,
          event_type: optionSelected,
        });
        setData(response.rows);
        setPagination({ ...pagi, total: response.count });
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }

    if (selected == "customer_email" && optionSelected == "") {
      try {
        const response = await EmailLogService.getAllAddress(emailparams);
        setData(response.rows);
        setPagination({
          ...pagi,
          total: response.count,
        });
      } catch (error) {
        console.error("deu erro");
      } finally {
        setLoading(false);
      }
    }
    if (selected == "customer_email" && !optionSelected == "") {
      try {
        const response = await EmailLogService.getByEmailAndEventType({
          recipient_address: searchQuery,
          event_type: optionSelected,
          page: pagi.current,
          limit: pagi.pageSize,
        });
        setData(response.data);
        setPagination({
          ...pagi,
          total: response.count,
        });
      } catch (error) {
        console.error("Erro ao mudar página:", error);
      } finally {
        setLoading(false);
      }
    }

    if (selected == "ses_config_set" && optionSelected == "") {
      try {
        const response = await EmailLogService.getLogBySesConfig(params);
        setData(response.rows);
        setPagination({
          ...pagi,
          total: response.count,
        });
      } catch (error) {
        console.error("deu erro");
      } finally {
        setLoading(false);
      }
    }

    if (selected == "ses_config_set" && !optionSelected == "") {
      try {
        const response = await EmailLogService.getBySesAndEvenType({
          ses_config_set: searchQuery,
          event_type: optionSelected,
          page: pagi.current,
          limit: pagi.pageSize,
        });
        setData(response.data);
        setPagination({
          ...pagi,
          total: response.count,
        });
      } catch (error) {
        console.error("Erro ao mudar página:", error);
      } finally {
        setLoading(false);
      }
    }

    setLoading(false);
  };

  const breadcrumb = [
    { title: "TIC", path: props.modulePath },
    { title: "Logs Email", path: props.module + "/emaillog" },
  ];

  const detailEvent = async (id) => {
    try {
      setLoadingModal(true);
      const detail = await EmailLogService.getEvent(id);
      console.log("API Detail:", detail);
      setEventData({ detail });
      setLoadingModal(false);
    } catch (error) {
      console.log(error);
      setLoadingModal(false);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onChange = (value) => {
    setOptionSelected(value);
  };
  const onSearch = (value) => {
    setOptionSelected(value);
  };

  return (
    <>
      <Helmet>Consulta</Helmet>
      <Main moduleName={props.moduleName} breadcrumb={breadcrumb}>
        <Row justify={"center"} style={{ marginBottom: "1rem" }}>
          <Col xs={24} sm={12} align="middle">
            <Col>
              <h1>Faça uma busca</h1>
            </Col>
            <Row justify={"center"} style={{ marginBottom: "1rem" }}>
              <Col span={20} style={{ paddingRight: "0.5em" }}>
                <Search
                  placeholder="Pesquisar..."
                  enterButton
                  onSearch={getLogs}
                />
              </Col>
            </Row>
            <Row justify={"center"} style={{ marginBottom: "1rem" }}>
              <Col className="select-container">
                {options.map((option) => (
                  <button
                    key={option.key}
                    onClick={() => setSelected(option.key)}
                    className={`select-button ${
                      selected === option.key ? "selected" : ""
                    }`}
                  >
                    {option.value}
                  </button>
                ))}

                <Select
                  showSearch
                  style={{ width: 310, marginTop: "5px" }}
                  placeholder="Tipo de Evento"
                  optionFilterProp="label"
                  onChange={onChange}
                  value={optionSelected}
                  onSearch={onSearch}
                  options={[
                    { value: "", label: "Nenhum Evento Selecionado" },
                    {
                      value: "Open",
                      label: "Abriu o E-mail",
                    },
                    {
                      value: "Delivery",
                      label: "Entregue",
                    },
                    {
                      value: "Send",
                      label: "Enviado",
                    },
                    {
                      value: "Bounce",
                      label: "E-mail não pôde ser entregue",
                    },
                    {
                      value: "Rendering Failure",
                      label: "Erro de Renderização",
                    },
                    {
                      value: "Complaint",
                      label: "Marcou como Spam/Denunciou",
                    },
                    {
                      value: "Reject",
                      label: "SES rejeitou envio",
                    },
                    {
                      value: "DeliveryDelay",
                      label: "Atraso na entrega do e-mail",
                    },
                    {
                      value: "Click",
                      label: "Clicou em link no E-mail",
                    },
                  ]}
                />
                <button
                  className="clear-filters"
                  onClick={() => {
                    setSelected("");
                    setOptionSelected("");
                    fetchData();
                    setSearchQuery("");
                  }}
                >
                  Limpar Filtros
                </button>
              </Col>
            </Row>
            <Divider />
          </Col>
          <Col span={24}>
            <Table
              rowKey="id"
              pagination={pagination}
              onChange={handleTableChange}
              loading={loading}
              columns={columns}
              dataSource={data}
              onRow={(record) => {
                return {
                  onClick: async () => {
                    setEventData({});
                    showModal();
                    await detailEvent(record.id);
                  },
                };
              }}
            />
          </Col>
        </Row>
        <Modal
          title={"DETALHES DO EVENTO"}
          open={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          width={"90%"}
          destroyOnClose={true}
        >
          {loadingModal ? (
            <>
              <div className="loading-centar">
                <img src={loadingSVG} alt="loading" height={80} />
              </div>
              <h2 className="text-loading">Carregando..</h2>
            </>
          ) : (
            <ModalEvent data={eventData} />
          )}
        </Modal>
      </Main>
    </>
  );
}

export default EmailsLogPage;
